import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonType } from '@/components/AdvertisePayments/components/Footer/Footer.types';
import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './Footer.styles';

type FooterCancelContinueProps = {
  onCancel?: () => void;
  onContinue?: () => void;
};

export const FooterCancelContinue: FC<FooterCancelContinueProps> = ({
  onCancel,
  onContinue
}) => {
  const isDark = useThemeMode('dark');
  const { t } = useTranslation();

  return (
    <S.FooterWrapper $isSticky>
      <S.ButtonsWrapper>
        <S.CancelButton
          $isDark={isDark}
          $type={ButtonType.DEFAULT}
          onClick={onCancel}
        >
          <S.ActionButtonLabel $isDark={isDark} $type={ButtonType.CANCEL}>
            {t('ConfirmModal.cancel_label')}
          </S.ActionButtonLabel>
        </S.CancelButton>
        <S.MainButton
          $isDark={isDark}
          $type={ButtonType.DEFAULT}
          onClick={onContinue}
        >
          <S.ActionButtonLabel $isDark={isDark} $type={ButtonType.MAIN}>
            {t('Advertise.btn_continue')}
          </S.ActionButtonLabel>
        </S.MainButton>
      </S.ButtonsWrapper>
    </S.FooterWrapper>
  );
};
